import { render, staticRenderFns } from "./teamStats.vue?vue&type=template&id=3e4f9794"
import script from "./teamStats.vue?vue&type=script&lang=js"
export * from "./teamStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports